export const AdobeAcrobatSignIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    // height="73.124"
    viewBox="0 0 75 73.124"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_216774"
          data-name="Rectangle 216774"
          width="75"
          height="73.124"
          fill="none"
        />
      </clipPath>
    </defs>
    <g id="Group_295384" data-name="Group 295384" clipPath="url(#clip-path)">
      <path
        id="Path_596526"
        data-name="Path 596526"
        d="M13.282,0H61.718A13.281,13.281,0,0,1,75,13.282V59.843A13.281,13.281,0,0,1,61.718,73.124H13.282A13.281,13.281,0,0,1,0,59.843V13.282A13.281,13.281,0,0,1,13.282,0"
        fill="#584ccc"
      />
      <path
        id="Path_596527"
        data-name="Path 596527"
        d="M56.406,38.76c-3.511-3.733-13.222-2.214-15.5-1.835a39.545,39.545,0,0,1-6.485-8.541,38.046,38.046,0,0,0,2.214-11.2c0-3.417-1.36-7.086-5.155-7.086a3.848,3.848,0,0,0-3.194,1.867c-1.613,2.783-.98,8.539,1.613,14.359-1.518,4.27-3.7,10.438-6.578,15.436-3.89,1.549-12.147,5.345-12.938,9.552a3.552,3.552,0,0,0,1.139,3.353,4.813,4.813,0,0,0,3.353,1.2c4.966,0,9.931-6.9,13.284-12.81a84.341,84.341,0,0,1,11.83-3.1c5.251,4.587,9.933,5.283,12.3,5.283,3.227,0,4.428-1.392,4.871-2.562a3.947,3.947,0,0,0-.758-3.922m-3.417,2.4c-.158.917-1.328,1.835-3.511,1.36a17.57,17.57,0,0,1-6.894-3.479,28.677,28.677,0,0,1,8.508-.127c1.012.191,2.182.76,1.9,2.247M30.342,13.171a1.271,1.271,0,0,1,1.108-.7c1.2,0,1.454,1.456,1.454,2.657a36.953,36.953,0,0,1-1.582,8.446c-2.024-5.377-1.74-9.109-.98-10.407m-.284,26.284a79.4,79.4,0,0,0,3.131-7.528,39.9,39.9,0,0,0,4.3,5.631,71.183,71.183,0,0,0-7.433,1.9M22.119,44.9c-3.194,5.124-6.327,8.35-8.16,8.35a1.3,1.3,0,0,1-.823-.284,1.178,1.178,0,0,1-.41-1.17c.348-1.835,3.985-4.492,9.394-6.9"
        transform="translate(3.652 3.578)"
        fill="#fff"
      />
    </g>
  </svg>
);
